module.exports = __webpack_public_path__ + "img/aviation_mix7.c767a97d.jpg";